import { render, staticRenderFns } from "./MainContentTabs.vue?vue&type=template&id=6a978bc0&scoped=true"
import script from "./MainContentTabs.vue?vue&type=script&lang=js"
export * from "./MainContentTabs.vue?vue&type=script&lang=js"
import style0 from "./MainContentTabs.vue?vue&type=style&index=0&id=6a978bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a978bc0",
  null
  
)

export default component.exports